var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cascader"},[_c('el-form-item',{attrs:{"label":_vm.attr.label,"prop":_vm.attr.name,"disabled":_vm.attr.disabled === '1',"label-width":(_vm.attr.labelWidth || _vm.labelWidth) + 'px',"rules":[
      {
        required: _vm.attr.required === '1',
        message: _vm.attr.label + '不能为空',
        trigger: 'submit'
      }
    ]}},[_c('el-cascader',{ref:"cascader",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.attr.disabled === '1',"props":_vm.props,"options":_vm.options,"placeholder":"请选择","filterable":"","clearable":""},on:{"change":_vm.handleChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }